import { useGLTF, useTexture } from "@react-three/drei"
import { MeshBasicMaterial, sRGBEncoding } from "three"
import { InstanceMesh } from "../Components/BakedMeshComponents"
import { treesObject } from "../../../ApartmentFinderConfig/instanceData"
// import { isIOS } from "../Utils/Helpers"
let isIOS = false

function InstanceGeometry() {
  const keys = Object.keys(treesObject)

  const { nodes } = useGLTF(
    `${process.env.PUBLIC_URL}/assets/apartmentfinder/instanceGeometry/treetypes.gltf`
  )

  const diffuseMap = useTexture(
    isIOS
      ? `${process.env.PUBLIC_URL}/assets/apartmentfinder/textures/treestexture.compressed.jpg`
      : `${process.env.PUBLIC_URL}/assets/apartmentfinder/textures/treestexture.jpg`
  )

  diffuseMap.flipY = false
  diffuseMap.encoding = sRGBEncoding

  const TREE_MAT = new MeshBasicMaterial({
    // color: "blue"
    // flatShading: true,
    toneMapped: false,
    map: diffuseMap
  })

  return keys.map(i => <InstanceMesh key={i} treeType={i} nodes={nodes} TREE_MAT={TREE_MAT} />)
  //   return <InstanceMesh />;
}

export default InstanceGeometry
